/**
 * Created by mukund on 5/1/17.
 */

angular.module('mediacloudApp')
    .directive('mediaInboxSearchResults', function(){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/collection/directives/media-inbox-search-results/media-inbox-search-results.html',
            scope: {
                openContent: '&',
                results: '=',
                all: '=',
                delete: '&',
                publish: '&',
                markAsNew: '&'
            },
            link: function(scope, element, attrs){
                scope.searchResultsPerPage = 5;
            }
        }
    });





